import Vue from 'vue'
import Vuex from 'vuex'
import AuthenticationStore from './vuex/authentication/store'
import LoadingStore from './vuex/loading/store'

// Activity Service
import ActivityContactStore from './vuex/ActivityService/ActivityContacts/store'
import ActivityCurrencyStore from './vuex/ActivityService/ActivityCurrencies/store'
import ActivityDiscountStore from './vuex/ActivityService/ActivityDiscounts/store'
import ActivityDiscountTypeStore from './vuex/ActivityService/ActivityDiscountTypes/store'
import ActivityPricingStore from './vuex/ActivityService/ActivityPricing/store'
import ActivityTypeStore from './vuex/ActivityService/ActivityTypes/store'
import ActivityStore from './vuex/ActivityService/Activities/store'

// Booking Service
import BookingStore from './vuex/BookingService/Bookings/store'
import BookingSearchStore from './vuex/BookingService/BookingSearch/store'
import BookingTypeStore from './vuex/BookingService/BookingTypes/store'
import CalendarStore from './vuex/BookingService/Calendar/store'
import ConservationFeeStore from './vuex/BookingService/ConservationFee/store'
import AutoStore from './vuex/BookingService/Autos/store'
import DriverStore from './vuex/BookingService/drivers/store'
import DestinationStore from './vuex/BookingService/Destinations/store'
import GatePassStore from './vuex/BookingService/GatePasses/store'
import GroupBookingTypeStore from './vuex/BookingService/GroupBookingTypes/store'
import PaymentMethodStore from './vuex/BookingService/PaymentMethods/store'
import VehicleFeeStore from './vuex/BookingService/VehicleFees/store'
import GateStore from './vuex/BookingService/Gates/store'
import PickUpLocationStore from './vuex/BookingService/PickUpLocations/store'
import FacilityPricingTypeStore from './vuex/BookingService/FacilityPricingType/store'
import NoteStore from './vuex/BookingService/Notes/store'
import SalesForce from './vuex/BookingService/SalesForce/store'
import SchoolStore from './vuex/BookingService/Schools/store'

// ADD THE NEW GLOBAL BOOKING STORE
import GlobalBookingStore from './vuex/BookingService/GlobalBookingStore'

// Currency Service
import CateringLevyStore from './vuex/CurrencyService/CateringLevy/store'
import CurrencyStore from './vuex/CurrencyService/Currency/store'
import VatStore from './vuex/CurrencyService/Vat/store'

// Facility Service
import AccommodationTypeStore from './vuex/FacilityService/AccommodationTypes/store'
import FacilityStore from './vuex/FacilityService/Facilities/store'
import FacilityContactStore from './vuex/FacilityService/FacilityContacts/store'
import FacilityCurrencyStore from './vuex/FacilityService/FacilityCurrencies/store'
import FacilityDiscountStore from './vuex/FacilityService/FacilityDiscounts/store'
import FacilityDiscountTypeStore from './vuex/FacilityService/FacilityDiscountTypes/store'
import FacilityMaintananceStore from './vuex/FacilityService/FacilityMaintanance/store'
import FacilityPricingStore from './vuex/FacilityService/FacilityPricing/store'
import FacilityPricingParameterStore from './vuex/FacilityService/FacilityPricingParameters/store'
import FacilityAllocationStore from './vuex/FacilityService/FacilityAllocation/store'
import FacilityExtraPricingStore from './vuex/FacilityService/FacilityExtraPricing/store'
import FacilityTypeStore from './vuex/FacilityService/FacilityTypes/store'

// Volunteer Service
import ProgramStore from './vuex/VolunteerService/Programs/store'
import VolunteerStore from './vuex/VolunteerService/Volunteers/store'
import VolunteerContactStore from './vuex/VolunteerService/VolunteerContacts/store'

// Partner Service
import PartnerStore from './vuex/PartnerService/Partners/store'
import PartnerTypeStore from './vuex/PartnerService/PartnerTypes/store'

// Member Service
import HouseHoldStore from './vuex/MemberService/HouseHolds/store'
import MemberStore from './vuex/MemberService/Members/store'
import CorporateMemberStore from './vuex/MemberService/Members/store'
import MemberTypeStore from './vuex/MemberService/MemberTypes/store'
import ResidenceTypeStore from './vuex/MemberService/ResidenceTypes/store'
import MembershipSettingStore from './vuex/MemberService/MembershipSettings/store'

// member v2 Service
import MemberV2Store from './vuex/MembershipServiceV2/Members/store'

// Amura Service
import UserTypeStore from './vuex/AmuraService/UserTypes/store'
import UserStore from './vuex/AmuraService/Users/store'
import MenuStore from './vuex/AmuraService/Menus/store'
import FeatureStore from './vuex/AmuraService/Features/store'
import CountryStore from './vuex/AmuraService/Countries/store'
import GenderStore from './vuex/AmuraService/Genders/store'

// Settings
import CallToActionStore from './vuex/SettingsService/CallToAction/store'
import HolidayStore from './vuex/SettingsService/Holidays/store'
import PageStore from './vuex/SettingsService/Pages/store'
import PageTypeStore from './vuex/SettingsService/PageTypes/store'

// Staff Service
import DepartmentStore from './vuex/StaffService/Departments/store'
import StaffStore from './vuex/StaffService/Staffs/store'

// Visitor Service
import IdentificationTypeStore from './vuex/VisitorService/IdentificationTypes/store'
import VisitorStore from './vuex/VisitorService/Visitors/store'
import VisitorTypeStore from './vuex/VisitorService/VisitorTypes/store'

// Donation Service
import AnonymityStore from './vuex/DonationService/Anonymity/store'
import CauseStore from './vuex/DonationService/Causes/store'
import DonationStore from './vuex/DonationService/Donations/store'
import PaymentFrequencyStore from './vuex/DonationService/PaymentFrequency/store'
import DonationPaymentMethodStore from './vuex/DonationService/PaymentMethods/store'

// Mpesa
import MpesaStore from './vuex/MpesaService/store'

// Logs
import LogStore from './vuex/Logs/store'

// Promo Codes
import PromoCodeStore from './vuex/PromoCodes/PromoCodes/store'
import PromoCodeTypeStore from './vuex/PromoCodes/PromoCodeTypes/store'

// Revenue & Charts
import ChartStore from './vuex/Reports/store'

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.config.debug = true

// const debug = process.env.NODE_ENV !== 'production'
const debug = false

export default new Vuex.Store({
  modules: {
    AuthenticationStore,
    LoadingStore,

    MemberV2Store,
    // Donation Service
    AnonymityStore,
    CauseStore,
    DonationStore,
    PaymentFrequencyStore,
    DonationPaymentMethodStore,
    // Visitor Service
    IdentificationTypeStore,
    VisitorStore,
    VisitorTypeStore,
    // Staff Service
    DepartmentStore,
    StaffStore,
    // Settings Sevice
    CallToActionStore,
    HolidayStore,
    PageStore,
    PageTypeStore,
    // Amura Service
    UserTypeStore,
    UserStore,
    MenuStore,
    FeatureStore,
    GenderStore,
    // Activity Service
    ActivityContactStore,
    ActivityCurrencyStore,
    ActivityDiscountStore,
    ActivityDiscountTypeStore,
    ActivityPricingStore,
    ActivityTypeStore,
    // Booking Service
    BookingStore,
    BookingSearchStore,
    BookingTypeStore,
    CalendarStore,
    ConservationFeeStore,
    AutoStore,
    DriverStore,
    DestinationStore,
    GatePassStore,
    GroupBookingTypeStore,
    PaymentMethodStore,
    VehicleFeeStore,
    GateStore,
    PickUpLocationStore,
    FacilityPricingTypeStore,
    NoteStore,
    SalesForce,
    SchoolStore,
    // ADD THE GLOBAL BOOKING STORE HERE
    GlobalBookingStore,
    // Currency Service
    CateringLevyStore,
    CurrencyStore,
    VatStore,
    // Facility Service
    AccommodationTypeStore,
    FacilityStore,
    FacilityContactStore,
    FacilityCurrencyStore,
    FacilityDiscountStore,
    FacilityDiscountTypeStore,
    FacilityMaintananceStore,
    FacilityPricingStore,
    FacilityTypeStore,
    FacilityPricingParameterStore,
    FacilityAllocationStore,
    FacilityExtraPricingStore,
    ActivityStore,
    // Volunteer Service
    CountryStore,
    ProgramStore,
    VolunteerStore,
    VolunteerContactStore,
    // Partner Service
    PartnerStore,
    PartnerTypeStore,
    // Member Service
    MembershipSettingStore,
    HouseHoldStore,
    MemberStore,
    CorporateMemberStore,
    MemberTypeStore,
    ResidenceTypeStore,
    // Mpesa
    MpesaStore,
    // Logs
    LogStore,
    // Promo Codes
    PromoCodeStore,
    PromoCodeTypeStore,
    // Reports & Charts
    ChartStore
  },
  strict: debug
})